import { useCallback, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DutyPostingService from "../services/dutyposting,service";

const CrewList = () => {
  const [search, setSearch] = useState("");
  const [search2, setSearch2] = useState("");
  const [filter, setFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [crewData, setCrewData] = useState([]);

  const [presentCrew, setPresentCrew] = useState([])
  const [absentCrew, setAbsentCrew] = useState([])
  const [allocatedCrew, setAllocatedCrew] = useState([])

  const [stats, setStats] = useState({
    total: "",
    driver: "",
    conductor: "",
    presentDrv: "",
    presentCond: "",
  });

  const getDrvList = useCallback(() => {
    const payload = {
      statuscode: "1",
    };
    const payload1 = {
      statuscode: "0",
    };
    const payload2 = {
      statuscode: "2",
    };
  
    DutyPostingService.getEmployees(payload)
      .then((resp) => {
        setPresentCrew(resp.data);
      })
      .catch((e) => console.log(e));
    DutyPostingService.getEmployees(payload1)
      .then((resp) => {
        setAbsentCrew(resp.data);
      })
      .catch((e) => console.log(e));

    DutyPostingService.getEmployees(payload2)
      .then((resp) => {
        setAllocatedCrew(resp.data);
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    getDrvList();
  }, [getDrvList]);

  useEffect(() => {
    console.log(presentCrew, absentCrew, allocatedCrew);
    const mergedArray = presentCrew.concat(absentCrew, allocatedCrew);
    console.log(mergedArray)
    setCrewData(mergedArray);

    const drvData = mergedArray.filter((item) => item.designation === "Driver");
    const condData = mergedArray.filter(
      (item) => item.designation === "Conductor"
    );

    const presentDrvData = mergedArray.filter(
      (item) => item.designation === "Driver" && item.statuscode === "1"
    );
    const presentCondData = mergedArray.filter(
      (item) => item.designation === "Conductor" && item.statuscode === "1"
    );

    const total = mergedArray.length;
    const driverCount = drvData.length;
    const condCount = condData.length;
    setStats({
      total: total,
      driver: driverCount,
      conductor: condCount,
      presentDrv: presentDrvData.length,
      presentCond: presentCondData.length,
    });
  }, [presentCrew, absentCrew, allocatedCrew]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    const keyword = e.target.value.toLowerCase();
    const data = crewData;
    const filteredData = data.filter(
      (row) =>
        (row.empname && row.empname.toLowerCase().includes(keyword)) ||
        (row.empcode && row.empcode.toLowerCase().includes(keyword))
    );

    if (keyword.length > 0) {
      setFilter(true);
    } else {
      setFilter(false);
    }
    setFilteredData(filteredData);
  };

  const columns = [
    {
      name: "Name",
      selector: (row) => row.empname,
      cell: (row) => (
        <>
          <div className="">{row.empname}</div>
        </>
      ),
      sortable: true,
    },
    {
      name: "Employee Code",
      selector: (row) => row.empcode,
      cell: (row) => (
        <>
          <div className="">{row.empcode}</div>
        </>
      ),
      sortable: true,
    },
    {
      name: "Tray Code",
      selector: (row) => row.traycode,
      cell: (row) => (
        <>
          <div className="">{row.traycode}</div>
        </>
      ),
      sortable: true,
    },
    {
      name: "Designation",
      selector: (row) => row.designation,
      cell: (row) => (
        <>
          <div className="">{row.designation}</div>
        </>
      ),
      sortable: true,
    },
    {
      name: "Duty No.",
      selector: (row) => row.allocationcode,
      cell: (row) => (
        <>
          <div className="">{row.allocationcode}</div>
        </>
      ),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.statuscode,
      cell: (row) => (
        <>
          <div className="">{row.statuscode}</div>
        </>
      ),
      sortable: true,
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row.statuscode === "1",
      style: {
        backgroundColor: "#93D5A0",
      },
    },
    {
      when: (row) => row.statuscode === "2",
      style: {
        backgroundColor: "#ADD8E6",
      },
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <div className="search-bar mt-3">
            <input
              type="text"
              placeholder="Search any columns"
              name="search"
              value={search}
              onChange={handleSearch}
            />
            <div className="search-icon">
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.8938 13.8677L17.5 17.5M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                    stroke="#A79EB7"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
          </div>
          <div className="stats">
            <div className="crew_count">
              <div className="count">
                <span className="count2">{stats.total}</span>
                <span>Total</span>
              </div>
              <div className="count">
                <span className="count2">{stats.driver}</span>
                <span>Driver</span>
              </div>
              <div className="count">
                <span className="count2">{stats.conductor}</span>
                <span>Conductor</span>
              </div>
              <div className="count">
                <span className="count2">{stats.presentDrv}</span>
                <span>Available Driver</span>
              </div>
              <div className="count">
                <span className="count2">{stats.presentCond}</span>
                <span>Available Conductor</span>
              </div>
            </div>
          </div>
          <div className="datatable_new">
            <DataTable
              columns={columns}
              data={filter ? filteredData : crewData}
              fixedHeader
              // pagination
              // conditionalRowStyles={conditionalRowStyles}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default CrewList;
